import { useCourseInvoice } from '@ts-core/hooks/invoices';
import { getAcademyCourseInvoiceQuery } from 'modules/academies/graphql/queries';

export default function useAcademyCourseInvoice({ courseId, invoiceId }) {
  return useCourseInvoice({
    query: getAcademyCourseInvoiceQuery,
    variables: { courseId, invoiceId },
    skip: !courseId || !invoiceId,
  });
}
